module.exports = __webpack_public_path__ + "static/media/logo147.95349681.png";